import { noop } from 'lodash';
import { memo } from 'react';

import { type Clip } from '@air/api/types';

import { DraggingOverlay } from '~/components/Gallery/DraggingOverlay';
import { DNDParentAsset } from '~/components/Shared/Drag/DNDParentAsset';
import DragType from '~/components/Shared/Drag/dragTypes';
import { DragDroppableFileShell, type DragDroppableFileShellProps } from '~/components/Shared/DragDroppableFileShell';
import { DropHighlight } from '~/components/Shared/DropHighlight';
import { GalleryFile, type GalleryFileProps } from '~/components/v2/components/shared/gallery/GalleryFile';

export type DNDGalleryFileProps = {
  enableDrag?: boolean;
  index: number;
} & GalleryFileProps<Clip> &
  Pick<DragDroppableFileShellProps, 'onDragStart'>;

export const DNDGalleryFile = memo(
  ({ enableDrag = true, file, index, onDragStart = noop, ...restOfProps }: DNDGalleryFileProps) => {
    return (
      <DragDroppableFileShell file={file} onDragStart={onDragStart} index={index} enabled={enableDrag}>
        <DNDParentAsset asset={file} dropLocation="file" style={{ height: '100%' }}>
          <DropHighlight borderRadius={18} />
          <GalleryFile {...restOfProps} file={file} />
          <DraggingOverlay itemId={file.id} type={DragType.file} />
        </DNDParentAsset>
      </DragDroppableFileShell>
    );
  },
);

DNDGalleryFile.displayName = 'DNDGalleryFile';
